import { GameApiService } from '../services/GameApiService';

export class GameApiPlugin {
  static install(Vue, options) {
    Vue.prototype.$gameApi = new GameApiService(Vue.prototype.$msal, Vue.prototype.msal);
  }
}
